export default function (isRs, cart){
  let originalPrice;
  if(isRs) {
    originalPrice = cart.items.reduce((sum, item) => {
      if (item !== null) {
        const { amount, old_amount: old } = item.product.prices[0];
        return sum + +(old || amount) * item.quantity;
      }

      return 0;
    }, 0);
  } else {
    originalPrice = cart.items.reduce((sum, item) => {
      if (item !== null) {
        const { price_last_30 } = item.product;
        const { amount, old_amount: old, price_type } = item.product.prices[0];
        let choosePrice;
        if(price_type === "simple_regular"){
          choosePrice = amount;
        } else if (price_type === "simple_loyalty"){
          choosePrice = old || amount;
        } else if (price_type) {
          choosePrice = price_last_30 > amount ? price_last_30 : amount;
        }
        return sum + (+choosePrice * item.quantity);
      }
      return 0;
    }, 0);
  };

  return originalPrice;
}